import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../../../@types/filter";
import { Paginated } from "../../../../../@types/paginated";
import { apisiseci } from "../../../../api";
import { useDefaultSearchParams } from "../../../../../hooks/useSearchParams";
import { AttendanceLocalDepartment } from "../../../../../@types/attendance-local-department";
import { AttendanceLocalDepartmentGuiche } from "../../../../../@types/attendance-local-department-guiche";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
  setor?: AttendanceLocalDepartment["id"]
};

export function useAttendanceLocalDepartmentGuicheList(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const defaultParams = useDefaultSearchParams();
  params = { ...defaultParams, ...params };

  return useQuery<Paginated<AttendanceLocalDepartmentGuiche>, AxiosError<{ detail: string }>>({
    enabled: !!token,
    queryKey: ['attendance-local', 'department', 'guiche', 'list', params],
    queryFn: async () => {
      const response = await apisiseci.get<Paginated<AttendanceLocalDepartmentGuiche>>(
        "/cms/guiches_setor/",
        { headers: { Authorization: `Bearer ${token}` }, params }
      );
      return response.data;
    },
  });
}
